import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const docebo = defineConnector({
  identifier: "docebo",
  name: "Docebo",
  tagLine: "Learning management platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a Docebo OAuth access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Docebo, create an API and SSO app, then exchange its credentials for an OAuth 2.0 access token. Use that access token as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your Docebo details",
      items: [
        {
          kind: "url",
          label: "Docebo base URL",
          required: true,
          placeholder: "https://your-company.docebosaas.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "OAuth access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://your-company.docebosaas.com"}/manage/v1/users`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://[^/]*\\.docebosaas\\.com/.*"),
});
